import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { getSubjects, setQuestionSubjectItem, getCategories, getCategoriesAll } from '../../actions';
import ButtonPanel from '../../../QbmPage/ButtonPanel';
import { connect } from 'react-redux'
import classNames from 'classnames';
import moment from 'moment';
import { MODAL_QUESTION_MULTY_SUBJECT_DELETE, MODAL_QUESTION_MULTY_SUBJECT_FORM, showModal } from '../../../../modules/modals';

class Subject extends Component {
  static contextTypes = {formatMessage: PropTypes.any};

  componentDidMount(){
    this.props.getSubjects();
    this.props.getCategoriesAll();
  }
  render() {
    const {formatMessage} = this.context;
    const {subjects, subject} = this.props;
    return (
        <div className="qbm-accordion-component">
          <div className="qbm-accordion-title">
            {formatMessage('titleQuestionSubject')}
          </div>
          <div className="posr qbm-accordion-body open">
            <div className="qbm-accordion-content">
              {subjects.map(item => (
                <div
                  key={`subject-item-${item.id}`}
                  className={classNames("qbm-accordion-content__item ", {'qbm-accordion-content__item--selected': subject && subject.id == item.id ? true : false})}
                  onClick={() => {
                    this.props.setQuestionSubjectItem(item);
                    this.props.getCategories(item.id);
                  }}
                >
                  <span className="text-ellipsis">{item.name}</span>
                </div>
              ))}
              {/* <div className="qbm-accordion-content__item qbm-accordion-content__item--selected"><span className="text-ellipsis">Test #2</span></div> */}
            </div>
            <ButtonPanel
              handleAddCreateClick = {() => {
                const { showModal } = this.props;
                showModal({
                  modalType : MODAL_QUESTION_MULTY_SUBJECT_FORM,
                  modalProps : {
                    initialValues: {}
                  }
                });
              }}
              handleDeleteClick = {() => {
                const { showModal } = this.props;
                showModal({
                  modalType : MODAL_QUESTION_MULTY_SUBJECT_DELETE,
                  modalProps : {
                    subject_id: subject.id
                  }
                });
              }}
              handleUpdateClick = {() => {
                const { showModal } = this.props;
                showModal({
                  modalType : MODAL_QUESTION_MULTY_SUBJECT_FORM,
                  modalProps : {
                    initialValues: {
                      ...subject, 
                    }
                  }
                });
              }}
              isUpdateActive = {!!subject}
              isDeleteActive = {!!subject}
            />
          </div>
          
        </div>
    );
  }
}

const mapStateToProps = (state) => ({
  subjects: state.question.subjects,
  subject: state.question.subject_selcted
})

const mapDispatchToProps = {
  getSubjects,
  showModal,
  setQuestionSubjectItem,
  getCategoriesAll,
  getCategories,
}


export default connect(mapStateToProps, mapDispatchToProps)(Subject)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Question/components/Subject/Subject.jsx